import React from 'react'
import SliderResults2026 from '../../component/slidercomponent/SliderResults2026'

const Results2026 = () => {
    return (
        <>

            <section className="events text-center" style={{marginTop:"-60px"}}>
                <div className="container-fluid">
                    <div className="sec-title text-center" >
                        <h2>100% Result Achievement – Session 2026 !</h2>
                        <div className="divider">
                            <span className="fa fa-mortar-board" />
                        </div>
                    </div>
                    <SliderResults2026 />

                </div>
            </section>

        </>
    )
}

export default Results2026